// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/solid/view-columns.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'view-columns',
  version: 'solid',
  paths: [
    {
      d: 'M16.8 20.4h3.3a2.7 2.7 0 0 0 2.7-2.7V6.3a2.7 2.7 0 0 0-2.7-2.7h-3.3v16.8M15 3.6H9v16.8h6V3.6m-11.1 0h3.3v16.8H3.9a2.7 2.7 0 0 1-2.7-2.7V6.3a2.7 2.7 0 0 1 2.7-2.7',
    },
  ],
}
